export type TFrequency = { name: string; value: "MONTHLY" | "QUARTERLY" | "SEMIANNUAL" | "ANNUAL" };

export const paymentFrequencyOptions: TFrequency[] = [
  { name: "Mensalmente", value: "MONTHLY" },
  { name: "Trimestralmente", value: "QUARTERLY" },
  { name: "Semestralmente", value: "SEMIANNUAL" },
  { name: "Anualmente", value: "ANNUAL" },
];
